import { NgIf, NgTemplateOutlet } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  standalone: true,
  imports: [
    NgTemplateOutlet,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    NgIf,
    FormsModule],
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {
  public isLoading: boolean = false

  constructor(private dialogRef: MatDialogRef<DeleteDialogComponent>) { }

  confirmDelete(): void {
    this.dialogRef.close(true);
  }
}
